// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2jf8R","rootSuccess":"CompleteLink_rootSuccess__11Q78","rootFailure":"CompleteLink_rootFailure__2CI43","isDisabled":"CompleteLink_isDisabled__3ZhFX"};